<template>
    <div>
      <modal-form
        :visible="visibleModalForm"
        :title="caja.id == null ? 'Registrar Caja' : 'Actualizar Caja'"
        :size="'lg'"
        @hide="closeModalForm"
      >
        <fieldset class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <legend>Datos Generales:</legend>
          <a-spin :spinning="success">
            <div class="container">
              <div class="d-flex flex-row-reverse bd-highlight">
                <small><strong>Los campos con (*) son obligatorios.</strong></small>
              </div>
              <hr style="border: 1px solid rgb(222, 222, 222);">
              <b-form @submit.stop.prevent="submitCaja">
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                    <strong>
                      <label for="gestion">Gestión :</label>
                    </strong>
                    <b-form-group label-for="gestion" :invalid-feedback="errors.first('gestion')" :state="!errors.has('gestion')">
                      <b-form-input 
                        v-model="caja.gestion" 
                        :state="errors.has('gestion') ? false : null"
                        v-validate="'required|max:64'"
                        data-vv-name="gestion"
                        data-vv-as="gestión"
                        type="text"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                    <strong>
                      <label for="cod_interno">N°/Código Interno * :</label>
                    </strong>
                    <b-form-group label-for="cod_interno" :invalid-feedback="errors.first('cod_interno')" :state="!errors.has('cod_interno')">
                      <b-form-input 
                        v-model="caja.cod_interno" 
                        :state="errors.has('cod_interno') ? false : null"
                        v-validate="'required|max:64'"
                        data-vv-name="cod_interno"
                        data-vv-as="n°/código interno"
                        type="text"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                    <strong>
                      <label for="cant_carpetas">Cantidad Carpetas * :</label>
                    </strong>
                    <b-form-group label-for="cant_carpetas" :invalid-feedback="errors.first('cant_carpetas')" :state="!errors.has('cant_carpetas')">
                      <b-form-input 
                        v-model="caja.cant_carpetas" 
                        :state="errors.has('cant_carpetas') ? false : null"
                        v-validate="'required|max:16'"
                        data-vv-name="cant_carpetas"
                        data-vv-as="catidad carpetas"
                        type="text"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                    <strong>
                      <label for="reg_inicial">Registro Inicial * :</label>
                    </strong>
                    <b-form-group label-for="reg_inicial" :invalid-feedback="errors.first('reg_inicial')" :state="!errors.has('reg_inicial')">
                      <b-form-input 
                        v-model="caja.reg_inicial" 
                        :state="errors.has('reg_inicial') ? false : null"
                        v-validate="'required|max:16'"
                        data-vv-name="reg_inicial"
                        data-vv-as="registro inicial"
                        type="number"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                    <strong>
                      <label for="reg_final">Registro Final * :</label>
                    </strong>
                    <b-form-group label-for="reg_final" :invalid-feedback="errors.first('reg_final')" :state="!errors.has('reg_final')">
                      <b-form-input 
                        v-model="caja.reg_final" 
                        :state="errors.has('reg_final') ? false : null"
                        v-validate="'required|max:16'"
                        data-vv-name="reg_final"
                        data-vv-as="registro final"
                        type="number"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <strong>
                      <label for="observaciones">Observaciones :</label>
                    </strong>
                    <b-form-group label-for="observaciones" :invalid-feedback="errors.first('observaciones')" :state="!errors.has('observaciones')">
                      <b-form-textarea 
                        style="border-color: #308e31;outline: 0px;box-shadow: rgba(0, 0, 0, 0.075) 0px 1px 1px inset, #9e020761 0px 0px 8px;"
                        v-model="caja.observaciones" 
                        :state="errors.has('observaciones') ? false : null"
                        v-validate="'max:128'"
                        data-vv-name="observaciones"
                        data-vv-as="observaciones"
                      ></b-form-textarea>
                    </b-form-group>
                  </div>
                </div>
                <div class="row my-2">
                  <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                    <b-button 
                      type="submit" 
                      class="float-right" 
                      variant="success"
                    ><i class="fa fa-check-circle" aria-hidden="true"></i> {{ caja.id == null ? 'REGISTRAR' : 'ACTUALIZAR' }}</b-button>
                    <b-button @click="closeModalForm" class="mr-2 float-right" variant="secondary"><i class="fa fa-times-circle" aria-hidden="true"></i> CANCELAR</b-button>
                  </div>
                </div>
              </b-form>
            </div>
          </a-spin>
        </fieldset>
      </modal-form>
      <b-card header-bg-variant="light">
        <template v-slot:header>
          <div>
            <span class="text-dark font-size-24 font-weight-bold">
              LISTA DE CAJAS EN ALMACÉN
            </span>
            <button
              @click="openModalForm"
              type="button"
              class="btn btn-success btn-with-addon mr-auto text-nowrap pull-right"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-plus-circle" />
              </span>
              Registrar Nuevo 
            </button>
          </div>   
        </template>
        <b-card-text>
          <a-skeleton active :loading="tabGeneral"/>
          <grid-general v-show="!tabGeneral" v-on:general='general' v-on:edit-box="editCaja"></grid-general>
        </b-card-text>
      </b-card>
    </div>
  </template>
  
  <script>
    import permission from '../../mixins/permission'
    import GridGeneral from '../../components/box/GridGeneral'
    import ModalForm from "../../components/widgets/Modals/ModalForm"
    import Caja from '../../models/Caja'
    import BoxService from '../../services/box.service'

    export default {
      components: {
        'grid-general': GridGeneral,
        "modal-form": ModalForm,
      },
  
      mixins: [permission],
  
      data() {
        return {
          tabGeneral: true,
          caja: new Caja(),
          success: false,
          visibleModalForm: false
        }
      },
  
      methods: {
        general(e) {
          this.tabGeneral = e
        },

        openModalForm() {
          this.visibleModalForm = true
        },

        closeModalForm() {
          this.visibleModalForm = false
          this.caja = new Caja()
        },

        editCaja(data) {
          this.caja.id = data.id
          this.caja.gestion = data.gestion
          this.caja.cod_interno = data.cod_interno
          this.caja.cant_carpetas = data.cant_carpetas
          this.caja.reg_inicial = data.reg_inicial
          this.caja.reg_final = data.reg_final
          this.caja.agencia_id = data.agencia_id
          this.caja.observaciones = data.observaciones
          this.openModalForm()
        },

        async submitCaja() {
          this.success = true
          this.$validator.errors.clear()
          // this.carpeta.agencia_id = this.id
          try {
            if(this.caja.id) {
              this._save = await BoxService.updateBox(this.caja.id, this.caja)
            } else {
              this._save = await BoxService.storeBox(this.caja)
            }
            if (this._save.status === 201 || this._save.status === 200) {
              this.closeModalForm()
              this.success = false
              this.$bus.$emit('evn-reload')
              this.$message.success(this._save.data.message)
            }
          } catch (err) {
            if(err.response.status === 422) this.$setErrorsFromResponse(err.response.data)
            if (err.response.status === 406) {
              this.closeModalForm()
              this.$notification.warning({
                message: 'Nota',
                description: err.response.data.message,
                duration: 10,
              })
            }
            this.success = false
          }
        }
      }
    }
  </script>
  <style scoped>
    fieldset {
      background-color: #f9f9f9;
      border-radius: 4px;
    }

    legend {
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 4px;
      color: #000;
      font-size: 17px;
      font-weight: bold;
      padding: 3px 5px 3px 7px;
      width: auto;
    }
  </style>